import { render } from "./PageNumber4.vue?vue&type=template&id=2db08c34&scoped=true"
import script from "./PageNumber4.vue?vue&type=script&lang=js"
export * from "./PageNumber4.vue?vue&type=script&lang=js"

import "./PageNumber4.vue?vue&type=style&index=0&id=2db08c34&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db08c34"]])

export default __exports__